import { IInternalState } from "./context";

export const LOADING = "LOADING";
export const SET_LOGS = "SET_LOGS";
export const SET_STATISTICS = "SET_STATISTICS";
export const SET_QUERY = "SET_QUERY";
export const RESET = "RESET";

export const initialState: IInternalState = {
  loading: [],
  logs: null,
  statistics: null,
  query: {
    page: 1,
    per_page: 10,
  },
};

const PriceAuditReducer = (state: IInternalState, action: any): IInternalState => {
  switch (action.type) {
    case LOADING:
      return { ...state, loading: action.payload };
    case SET_LOGS:
      return { ...state, logs: action.payload };
    case SET_STATISTICS:
      return { ...state, statistics: action.payload };
    case SET_QUERY:
      return { ...state, query: action.payload };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

export default PriceAuditReducer;
